import React from "react";
import { reportCrash } from "../utils/crashReporting";

interface Props {
  children: React.ReactNode;
}

interface State {
  error: Error | null;
}

export default class ErrorBoundary extends React.Component<Props, State> {
  state: State = { error: null };

  static getDerivedStateFromError(error: Error): State {
    return { error };
  }

  componentDidCatch(error: Error, info: React.ErrorInfo) {
    reportCrash(error.message, error.stack, { componentStack: info.componentStack });
  }

  private handleReload = () => {
    window.location.reload();
  };

  render() {
    if (!this.state.error) return this.props.children;

    return (
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          height: "100vh",
          gap: "1rem",
          padding: "2rem",
          textAlign: "center",
          fontFamily: "inherit",
        }}
      >
        <h1 style={{ fontSize: "1.25rem", margin: 0 }}>Something went wrong</h1>
        <p style={{ color: "#64748B", maxWidth: "32rem", margin: 0 }}>
          HyperPDF hit an unexpected error and can&apos;t continue safely. Reloading
          should get you back to a working state; your file on disk hasn&apos;t
          been touched.
        </p>
        <button
          onClick={this.handleReload}
          style={{
            padding: "0.5rem 1.25rem",
            borderRadius: "0.5rem",
            border: "none",
            background: "#2563EB",
            color: "#FFFFFF",
            cursor: "pointer",
            fontSize: "0.9rem",
          }}
        >
          Reload HyperPDF
        </button>
      </div>
    );
  }
}
